export enum SequenceFollowupsModeEnum {
  Auto = 'AUTO',
  Custom = 'CUSTOM',
}
